<script>
import { Line, mixins } from "vue-chartjs";
import chartMixin from "./Mixin";
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp, chartMixin],
};
</script>
